export default "__VITE_ASSET__MjbuNYSK__"